/**
 * @generated SignedSource<<0a82c8198aa1cf88d2aa3c5df1ac525b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeQuery$variables = {
  first?: number | null | undefined;
  isPublicInternet?: boolean | null | undefined;
};
export type HomeQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Home_query">;
};
export type HomeQuery = {
  response: HomeQuery$data;
  variables: HomeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPublicInternet"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "isPublicInternet",
    "variableName": "isPublicInternet"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "Home_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeQuery",
    "selections": [
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "LandingPageConnection",
            "kind": "LinkedField",
            "name": "landingPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LandingPageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandingPage",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "landingPage(first:100)"
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "JobPostingConnection",
            "kind": "LinkedField",
            "name": "jobPostings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JobPostingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobPosting",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HiringBanner",
            "kind": "LinkedField",
            "name": "hiringBanner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "height",
                        "value": 400
                      },
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 1440
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": "url(height:400,width:1440)"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "66b834be8aa0d18be82d5b4d4ad8f757",
    "id": null,
    "metadata": {},
    "name": "HomeQuery",
    "operationKind": "query",
    "text": "query HomeQuery(\n  $first: Int\n  $isPublicInternet: Boolean\n) {\n  ...Home_query_3FFVDC\n}\n\nfragment HomeBanner_query on Query {\n  company: companyDomainName {\n    hiringBanner {\n      banner {\n        url(width: 1440, height: 400)\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment HomeJobPostings_query_3FFVDC on Query {\n  company: companyDomainName {\n    jobPostings(first: $first, isPublicInternet: $isPublicInternet) {\n      edges {\n        node {\n          id\n          ...JobPostCard_jobPosting\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment HomeLandingPage_query on Query {\n  company: companyDomainName {\n    landingPage(first: 100) {\n      edges {\n        node {\n          id\n          title\n          content\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment Home_query_3FFVDC on Query {\n  ...HomeLandingPage_query\n  ...HomeJobPostings_query_3FFVDC\n  ...HomeBanner_query\n  company: companyDomainName {\n    nameFriendly\n    id\n  }\n}\n\nfragment JobPostCard_jobPosting on JobPosting {\n  id\n  title\n}\n"
  }
};
})();

(node as any).hash = "6d049d0681de5ef5deb8e5c3e52bfbd0";

export default node;
